import React from 'react'
import styled from 'styled-components'

const H1 = styled.h1`
font-size:4rem;
text-align:center;
`

export default props=> <H1>{props.children}</H1>